import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionOptionMaxDailyStockNum } from "./max-daily-stock-num";
import { QuestionOptionMaxStockNum } from "./max-stock-num";

import type { StandardOptionCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	stock: StandardOptionCategoriesAndManagerStore["stock"];
};

export const QuestionOptionStock = ({ stock }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper categoryStore={stock}>
				<QuestionOptionMaxDailyStockNum />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="高度な在庫設定" categoryStore={stock}>
				<QuestionOptionMaxStockNum />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionOptionStock.displayName = "QuestionOptionStock";
